import React from 'react';
import { getPrimary, getSecondary } from '../../styles/colors';
import {
	AlertConfirm, BasicButton, Radio, TextInput
} from '../../UI';

const ModalNewItem = ({
	translate,
	setLocalState,
	item,
	isDuplicatedItem,
	label,
}) => {
	const [newMain, setNewMain] = React.useState(false);
	const [newItem, setNewItem] = React.useState(item);
	const [error, setError] = React.useState('');

	React.useEffect(() => {
		setNewItem(item);
	}, [item]);

	const emptyError = 'El valor no puede estar vacío';
	const duplicatedError = 'El valor ya está en uso';

	const valueTypes = [
		{
			label: 'Texto',
			value: 'text'
		},
		{
			label: 'Numero',
			value: 'number'
		},
		{
			label: 'Booleano',
			value: 'boolean'
		},
	];

	const setValue = value => {
		// Empty value
		if (!value) {
			setNewItem({
				...newItem,
				value
			});
			setError(emptyError);
			return;
		}
		// Text type
		if (item?.valueType === 'text') {
			setNewItem({
				...newItem,
				value
			});
			if (isDuplicatedItem(value)) {
				setError(duplicatedError);
			} else setError('');
			return;
		}
		// Number type
		if (item?.valueType === 'number') {
			setNewItem({
				...item,
				value: parseFloat(value)
			});
			if (isDuplicatedItem(parseFloat(value))) {
				setError(duplicatedError);
			} else setError('');
			return;
		}
		// Boolean types
		if (item?.valueType === 'boolean' && value === 'true') {
			setNewItem({
				...item,
				value: true
			});
			if (isDuplicatedItem(true)) {
				setError(duplicatedError);
			} else setError('');
			return;
		}
		if (item?.valueType === 'boolean' && value === 'false') {
			setNewItem({
				...item,
				value: false
			});
			if (isDuplicatedItem(false)) {
				setError(duplicatedError);
			} else setError('');
		}
	};

	return (
		<div style={{
			marginLeft: '1em',
		}}>
			<BasicButton
				color='white'
				text={label}
				onClick={() => setNewMain(true)}
				backgroundColor={{
					backgroundColor: getSecondary(),
					border: `1px solid ${getSecondary()}`,
					boxShadow: 'none',
					color: 'white',
					fontWeight: 'bold',
					height: '30px',
					width: '145px',
				}}
			/>
			<AlertConfirm
				open={newMain}
				title={'Valores de la opcion'}
				buttonAccept={translate.save}
				buttonCancel={translate.cancel}
				cancelAction={() => {
					setNewItem(item);
					setNewMain(false);
				}}
				hideAccept={!!error}
				acceptAction={() => {
					setLocalState({ ...newItem });
					setNewMain(false);
				}}
				requestClose={() => setNewMain(true)}
				bodyStyle={{ minWidth: '60vw' }}
				bodyText={
					<div
						style={{
							display: 'flex', flexDirection: 'column', rowGap: '1em'
						}}
					>
						<div style={{
							border: `2px solid ${getPrimary()}`,
							padding: '4px',
						}}>
							<span style={{
								color: getPrimary(),
								fontSize: '18px'
							}}>
								Tipo de valor
							</span>
							<br/>
							{/* VALUE TYPE */}
							{valueTypes
							&& <div
								style={{
									display: 'flex', justifyContent: 'space-evenly'
								}}
							>
								{valueTypes.map(type => (
									<Radio
										key={type.value}
										styleLabel={{ margin: '0' }}
										name="inputType"
										label={type.label}
										value={type.value}
										checked={newItem?.valueType === type.value}
										onChange={event => setNewItem({
											...newItem,
											valueType: event.target.value
										})}
									/>
								))}
							</div>}
						</div>
						<div style={{
							border: `2px solid ${getSecondary()}`,
							padding: '4px',
						}}>
							<span style={{
								color: getSecondary(),
								fontSize: '18px'
							}}>
								Valor
							</span>
							<TextInput
								floatingText={'Valor'}
								onChange={event => setValue(event.nativeEvent.target.value)}
								errorText={error}
								value={newItem.value}
							/>
						</div>
						<div style={{
							border: `2px solid ${getPrimary()}`,
							padding: '4px',
						}}>
							<span style={{
								color: getPrimary(),
								fontSize: '18px'
							}}>
								Clave de traducción
							</span>
							<TextInput
								floatingText={'Label'}
								onChange={event => {
									setNewItem({
										...newItem,
										label: event.nativeEvent.target.value
									});
								}}
								value={newItem.label}
							/>
							<div>
								Traducción: {translate[newItem.label] ? translate[newItem.label] : '*No funciona la key o está mal escrita'}
							</div>
						</div>
						<div style={{
							border: `2px solid ${getSecondary()}`,
							padding: '4px',
							marginTop: '4px'
						}}>
							<span style={{
								color: getSecondary(),
								fontSize: '18px'
							}}>
								Traducción personalizada por idioma
							</span>
							{Object.keys(newItem.text).map(key => (
								<TextInput
									key={key}
									floatingText={key}
									value={newItem.text[key]}
									onChange={event => {
										setNewItem({
											...newItem,
											text: {
												...newItem.text,
												[key]: event.nativeEvent.target.value
											}
										});
									}
									}
								/>
							))}
						</div>

					</div>
				}
			/>
		</div>
	);
};


export default ModalNewItem;

